import { useContentOverflow } from '../../../../../hooks'
import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'

import * as styles from './CreatePasswordFormRequirementsItem.module.css'

function CreatePasswordFormRequirementsItem({
  className = styles.CreatePasswordFormRequirementsItem,
  text,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <FloatingTooltip content={text} disabled={!overflow}>
      <div className={className}>
        <div className={styles.dotIconContainer} />
        <Text ref={setContentOverflowRef}>{text}</Text>
      </div>
    </FloatingTooltip>
  )
}

export default CreatePasswordFormRequirementsItem
